import { ChainId } from '../constants';

import user from '@/stores/user';
import AlertFunc from '@/utils/components/alert';
import { useSwitchChain } from 'wagmi';

function handleError(e: any) {
    console.error(e);
    let message;
    if ((e as any).code === 4001) {
        return;
    }
    if ((e as any).code === -32002) {
        message = 'Please approve the chain change request in your wallet';
    }

    AlertFunc({
        type: 'error',
        duration: 10000,
        text:
            message ||
            (e as any).message ||
            'Something wrong, please try again later',
    });
}

export default function useWeb3SwitchNetwork() {
    const { switchChainAsync } = useSwitchChain();
    function handleChangeNetwork(cid: ChainId) {
        return new Promise(async (resolve) => {
            if (user.isPolis) {
                resolve(true);
                return;
            }

            const res = await switchChainAsync({
                chainId: cid,
            });
            if (res.id === cid) {
                resolve(true);
            } else {
                resolve(false);
            }
        });
    }

    return {
        handleChangeNetwork,
    };
}
